export const statuses = {
  accepted: 'accepted',
  rejected: 'rejected',
  removed: 'removed',
  await: 'await',
  draft: 'draft',
  history: 'history'
}

export const statusFilters = {
  [statuses.accepted]: 'опубликовано',
  [statuses.rejected]: 'отклонено',
  [statuses.removed]: 'удалено',
  [statuses.await]: 'ожидает',
  [statuses.draft]: 'черновик',
  [statuses.history]: 'все'
}

export const statusTranslates = {
  [statuses.accepted]: 'Подтверждено',
  [statuses.rejected]: 'Отклонено',
  [statuses.removed]: 'Снято с публикации',
  [statuses.await]: 'Ожидают рассмотрения',
  [statuses.draft]: 'Черновик',
  [statuses.history]: 'История изменений контента'
}

export const statusBadges = {
  [statusFilters[statuses.accepted]]: 'primary',
  [statusFilters[statuses.rejected]]: 'danger',
  [statusFilters[statuses.removed]]: 'dark',
  [statusFilters[statuses.draft]]: 'secondary',
  [statusFilters[statuses.await]]: 'info'
}
